import Vue from 'vue'

const state = {
  user: JSON.parse(localStorage.getItem('auth.user')),
  token: localStorage.getItem('auth.token'),
}

const getters = {
  user: (state) => state.user,
  token: (state) => state.token,
  isAuthenticated: (state) => !!state.user,
}

const mutations = {
  setToken(state, token) {
    state.token = token
    localStorage.setItem('auth.token', token)
  },

  setUser(state, user) {
    state.user = user
    localStorage.setItem('auth.user', JSON.stringify(user))
  },

  logout(state) {
    state.user = null
    state.token = null
    localStorage.removeItem('auth.token')
    localStorage.removeItem('auth.user')
  },
}

const actions = {
  async loginAction({ commit }, user) {
    let response = await Vue.axios.post('/api/site/token', {
      email: user.email,
      password: user.password,
    })
    commit('setToken', response.data.data)
    response = await Vue.axios.get('/api/site/account')
    commit('setUser', response.data.data)
  },

  logoutAction({ commit }) {
    commit('logout')
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
